<script lang="ts" setup>
import {
  useNavState,
  useSidebar,
  type ApiReferenceConfiguration,
} from '@scalar/api-reference'
import { computed, inject } from 'vue'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore dynamic import names
import { data } from '@/assets/X8SKCfOX7TI7OjKIbQqfH.js'
import { useSidebarState } from '@/hooks'
import Reference from '@/views/references/Reference.vue'
import {
  type PublishReferenceProps,
  type ReferenceStaticData,
} from '@/views/references/types'

const props = defineProps<PublishReferenceProps>()

const { sidebarState } = useSidebarState()

const proxyUrl = inject('proxyUrl') as string

if (!proxyUrl) console.error('Proxy is not injected')

function parseConfig(config?: string) {
  try {
    return JSON.parse(config ?? '{}')
  } catch (error) {
    console.log(error)
    return {}
  }
}

/** Custom config parsed from the user provided reference config */
const configuration = computed((): ApiReferenceConfiguration => {
  const reference = props.version.references[props.referenceUid]

  const customConfig = parseConfig(reference.config)

  return {
    proxyUrl,
    showSidebar: sidebarState.showSidebar,
    hideSearch: true,
    content: data.content,
    ...customConfig,
  }
})

/**
 * Set the first tag open
 * This should only ever be run once so we can use a global variable on first set
 * to prevent re-running on each component mount
 */
const firstTag = (data as ReferenceStaticData).parsed?.tags?.[0]
if (
  !import.meta.env.SSR &&
  firstTag &&
  !(window as any)['isLoaded-X8SKCfOX7TI7OjKIbQqfH']
) {
  ;(window as any)['isLoaded-X8SKCfOX7TI7OjKIbQqfH'] = true

  const navState = useNavState(configuration)

  const { setCollapsedSidebarItem } = useSidebar(data.parsed, {
    config: configuration,
    ...navState,
  })

  const { getTagId } = useNavState()
  setCollapsedSidebarItem(getTagId(firstTag), true)
}
</script>

<template>
  <Reference
    v-bind="props"
    :configuration
    :parsed="<any>data.parsed"
    :raw="data.content" />
</template>
